import Image, { ImageProps } from "next/image";
import { crypto_images } from "@/components/crypto_images";

interface CurrencyIconProps extends Omit<ImageProps, "src" | "alt"> {
    currencyCode: string;
    alt?: string;
}

/**
 * Компонент для отображения иконки валюты/криптовалюты
 * Автоматически возвращает generic иконку, если конкретная не найдена
 * 
 * @param currencyCode - код валюты (например, 'btc', 'eth', 'USD')
 * @param alt - альтернативный текст для изображения (по умолчанию пустая строка)
 * @param ...props - остальные пропсы компонента Image из next/image
 */
export const CurrencyIcon = ({ 
    currencyCode, 
    alt = "", 
    ...imageProps 
}: CurrencyIconProps) => {
    const normalizedCode = currencyCode?.toLowerCase() || "";
    const imageSrc = crypto_images[normalizedCode] || crypto_images['generic'];
    
    return (
        <Image 
            src={imageSrc} 
            alt={alt}
            {...imageProps}
        />
    );
};

